import { Subject } from 'rxjs';
import { Drawing, Feature } from '../common/interfaces';

export abstract class IFeatureFlagService {
  featuresChanged$ = new Subject<void>();
  abstract isFeatureSupported(feature: Feature): boolean;
  abstract updateDrawing(drawing: Drawing): void;
  abstract updateUserFlags(featureFlags: Feature[]): void;
}
